import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { WidgetVideoTutorialsComponent } from "../Components/WidgetVideoTutorialsComponent";
import { PopupVideoTutorialsComponent } from "../Popups/PopupVideoTutorialsComponent";

export class WidgetVideoTutorialsProps {
    public title: LanguageString;
    public selectedVideoTutorialIds: number[];

    constructor() {
        this.title = new LanguageString();
    }
}

export class WidgetVideoTutorials extends WidgetBase {
    props: WidgetVideoTutorialsProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetVideoTutorialsProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.VideoTutorials;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (!this.props.selectedVideoTutorialIds) {
                this.props.selectedVideoTutorialIds = [];
            }

            if (this.props.title == null)
                this.props.title = new LanguageString();
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetVideoTutorialsComponent({
            widget: this,
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupVideoTutorialsComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}